module.exports = __webpack_public_path__ + "components/flag/static/square/ad-02dac59a9eebee92d1d09780787933bd.svg";